export default "__VITE_ASSET__CkJrOvGV__"